import { combineEpics } from 'redux-observable';

import fetchBookingEpic from './epics/fetchBooking';
import confirmCheckIn from './epics/confirmCheckIn';

export default combineEpics(fetchBookingEpic, confirmCheckIn);
